import { useEffect } from 'react'
import { clearExpiredDismissals } from '../utils/paywallStorage'
import { useUnifiedBilling } from './global-billing'
import type { PaywallState } from '@highlight/common/types'

export type { PaywallState }

/**
 * Main hook for paywall state management
 * Reads from GlobalStore - safe to use anywhere
 */
export const usePaywallState = (): PaywallState => {
  const { paywall } = useUnifiedBilling()
  useEffect(() => {
    clearExpiredDismissals()
  }, [])
  return paywall
}
